import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Diamondyeppy = () => {
  return (
    <div className="diamond_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={4}>
            <h2>Double Diamond Figure</h2>
            <p>
              The Double Diamond design process is a design thinking framework
              that consists of four phases
            </p>
            <ul>
              <li>Discover</li>
              <li>Define</li>
              <li>Develop</li>
              <li>Deliver</li>
            </ul>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={8}>
            <div className="diamond_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/design_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1002}
              />
            </div>
          </Col>
        </Row>

        <Row className="padd_top">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h4>Discover Phase</h4>
            <ul>
              <li>Research and User Insights</li>
              <p>
                We conducted interviews, surveys, and observations to gather
                insights into Aisha's specific needs and challenges.
              </p>
              <p>
                Then we explored the grocery shopping habits and pain points of
                other housewives in Dubai. At last, we tried to understand the
                competitive landscape in the region's grocery delivery market.
              </p>
              <li>User Persona Development</li>
              <p>
                We created a detailed user persona based on the information
                collected, including Aisha's goals, challenges, and aspirations.
              </p>
              <li>Problem Framing</li>
              <p>
                We defined the core problem to be addressed, such as "How might
                we make grocery shopping more convenient and efficient for
                housewives like Aisha in Dubai?"
              </p>
            </ul>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="discover_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/discover_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={754}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Diamondyeppy;
